unit CategoryItemListType;
{

/* Initial. */

}
interface

uses
  JS,
  CategoryItemType;

type
  TCategoryItemArray = array of TCategoryItemType;

  TCategoryItemListType = class
    fCategoryItemArray: TCategoryItemArray;
  public
    property CategoryItemArray: TCategoryItemArray read fCategoryItemArray;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TCategoryItemListType.Create(const String_JSON: String);
var JSArray_ListType: TJSArray;
    JSValue_Type: JSValue;
    CategoryItemType: TCategoryItemType;
begin
  if String_JSON <> 'null' then
  begin
    JSArray_ListType := TJSArray(TJSJSON.parseobject(String_JSON));

    for JSValue_Type in JSArray_ListType do
    begin
      CategoryItemType := TCategoryItemType.Create(TJSJSON.stringify(JSValue_Type));

      Insert(CategoryItemType, fCategoryItemArray, High(fCategoryItemArray));
    end;
  end;
end;


end.
